import React from 'react';

const testimonials = [
  {
    name: "Maria D.",
    role: "Restaurant Owner",
    image: "https://restaff.b-cdn.net/Screenshots/Maria%20D.png",
    quote: "Before ReStaff we were juggling spreadsheets, group chats, and a punch clock app. Now scheduling, shift swaps, and time tracking are all in one place. It saves us hours every week."
  },
  {
    name: "James R.",
    role: "Cleaning Company Owner",
    image: "https://restaff.b-cdn.net/Screenshots/James%20R.png",
    quote: "Managing shifts for our cleaning crews used to take hours every week. With ReStaff we schedule teams, track hours, and handle last-minute changes in minutes."
  },
  {
    name: "Linda B.",
    role: "Operations Manager",
    image: "https://restaff.b-cdn.net/Screenshots/Linda%20B..png",
    quote: "We manage multiple teams and schedules every day. ReStaff made workforce management simple — everyone sees their shifts instantly and payroll hours are accurate."
  }
];

export function TestimonialsSection() {
  return (
    <section className="py-10 md:py-20 bg-white" aria-label="Testimonials">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">

        <div className="text-center mb-8 md:mb-12">
          <p className="text-xs font-bold tracking-widest text-orange-500 uppercase mb-3">Testimonials</p>
          <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 mb-3" style={{ fontFamily: 'Manrope' }}>
            What business owners say
          </h2>
          <p className="text-slate-500 text-base max-w-xl mx-auto">
            Teams across multiple industries rely on ReStaff to manage their workforce more efficiently.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.map((t) => (
            <div
              key={t.name}
              className="bg-slate-50 border border-slate-100 rounded-2xl shadow-sm p-6 flex flex-col items-center text-center"
            >
              <img
                src={t.image}
                alt={t.name}
                className="w-16 h-16 rounded-full object-cover border-2 border-white shadow mb-4"
                onError={e => { e.target.style.display = 'none'; }}
              />
              <p className="text-slate-600 text-sm leading-relaxed mb-5 flex-1">
                "{t.quote}"
              </p>
              <div>
                <p className="font-bold text-slate-900 text-sm">{t.name}</p>
                <p className="text-slate-400 text-xs mt-0.5">{t.role}</p>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}
